/**
 * Mapbox client calls — go through our Worker proxy so the token stays server-side
 */

import { api } from './api.js';
import type { GeoFeature, Route } from '../types/index.js';

export async function geocode(query: string, proximity?: string, types?: string, limit?: number): Promise<GeoFeature[]> {
  const params = new URLSearchParams({ q: query });
  if (proximity) params.set('proximity', proximity);
  if (types) params.set('types', types);
  if (limit) params.set('limit', String(limit));
  const result = await api.get<{ features: GeoFeature[]; count: number }>(`/maps/geocode?${params}`);
  if (!result.success) return [];
  return result.data.features;
}

export async function getDirections(
  origin: [number, number],   // [lng, lat]
  dest: [number, number],
  waypoints: [number, number][] = [],
  profile: 'driving' | 'driving-traffic' | 'walking' | 'cycling' = 'driving-traffic',
): Promise<Route | null> {
  const originStr = origin.join(',');
  const destStr = dest.join(',');
  const waypointsStr = waypoints.map(w => w.join(',')).join(';');
  const params = new URLSearchParams({ origin: originStr, dest: destStr, profile });
  if (waypointsStr) params.set('waypoints', waypointsStr);

  const result = await api.get<{ routes: Route[] }>(`/maps/directions?${params}`);
  if (!result.success) return null;
  return result.data.routes?.[0] ?? null;
}
